<template>
    <div class="content-area">
        <div class="form-layout">
            <div class="form-info">
                <el-form :model="retailerCom" ref="ruleForm" class="demo-ruleForm">
                    <div class="form-row">
                        <div class="form-label">
                            <label class="required">是否门店</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="auditState">
                                <el-radio-group v-model="retailerCom.shopFlag">
                                    <el-radio :label=-1>全部机构</el-radio>
                                    <el-radio :label=1>门店</el-radio>
                                    <!--<el-radio :label=0>非门店</el-radio>-->
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-row" v-if="retailerCom.shopFlag == 1 && retailerShopTagList.length > 0">
                        <div class="form-label">
                            <label>机构标签</label>
                        </div>
                        <div class="form-value">
                            <ul class="enum-list">
                                <li v-for="(item,index) in retailerShopTagList" class="enum-item" v-bind:class="{checked: tagIds.indexOf(item.id) >= 0 }" v-model="retailerCom.tagId" @click="changShopTag(item)">
                                    <span>{{item.name}}</span>
                                    <i></i>
                                </li>
                            </ul>
                        </div>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import retailerApi from '../../api/retailer'
    export default {
        name: 'swb-com-download',
        desc: '导出公司信息',
        props: {
            merchantId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                retailerShopTagList: [],
                retailerCom: {
                    shopFlag: -1,
                },
                tagIds: [],

            }
        },
        created: function () {
            this.getShopTag();
        },
        methods: {
            getShopTag: function () {
                let postData = {};
                let self = this;
                let loading = MsgBox.loading();
                retailerApi.getRetailerShopTagList(postData, function (result) {
                    loading.hide();
                    if(result.type == "info") {
                        self.retailerShopTagList = result.data || [];
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                // 提供回调函数，返回结果
                let self = this;
                let result = {};
                this.$refs['ruleForm'].validate(function (valid) {
                    if(valid) {
                        let retailerCom = self.retailerCom;
                        let selectShopFlag = null;
                        if(retailerCom.shopFlag == 1) {
                            selectShopFlag = true;
                        }
                        let postData = {
                            shopFlag: selectShopFlag,
                            tagIds: self.tagIds
                        }
                        result.data = postData;
                        result.type = "info";
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败';
                    }
                });
                return result;
            },
            changShopTag: function (item) {
                let self = this;
                let tagIds = self.tagIds;
                let retailerCom = self.retailerCom;
                let shopFlag = retailerCom.shopFlag;
                if(!shopFlag) {
                    retailerCom.tagId = null;
                    retailerCom.tagName = null;
                } else {
                    if(tagIds.indexOf(item.id) >= 0) {
                        let tagId = tagIds.find(function (id) {
                            return item.id == id;
                        });
                        tagIds.remove(tagId);
                    } else {
                        tagIds.push(item.id);
                    }
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/orgStruct/DownloadCom.vue